export default "__VITE_ASSET__DyOpPdzp__"